import React from 'react';
import {Route, IndexRoute, Redirect} from 'react-router';

import RootApp from './containers/RootApp';
import ShowcaseCollectionRoute from './routes/showcase-collection-route';
import EPGRoute from './routes/epg-route';
import NpvrRoute from './routes/npvr-route';
import NotificationsRoute from './routes/notifications-route';
import AssetRoute from './routes/asset-route';
import ShowcaseFavoritesRoute from './routes/favorites-route';
import SearchRoute from './routes/search-route';
import RelatedRoute from './routes/related-route';
import PurchasesRoute from './routes/purchases-route';
import IndexRouteComponent from './routes/index-route';

import {SetSettingsState} from './actions/common/actions-common';
import {getScroll} from './utils';

import _get from 'lodash/get';

export default (store) => {

  const checkAuth = function (nextState, replace) {

    if (_get(store.getState(), 'auth.user.user', 'guest') === 'guest') {

      store.dispatch(SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      }));

      replace({
        pathname: '/',
        state: {nextPathname: nextState.location.pathname}
      });

    }
  };

  return (<Route path="/" component={RootApp}>
    <IndexRoute component={IndexRouteComponent} />
    <Route path="/showcase/:url" component={ShowcaseCollectionRoute} metadata={{startLimit: 18, nextLimit: 18, isDynamic: true}} />
    <Route path="/asset/:asset_id" component={AssetRoute} />
    <Route path="/favorites" component={ShowcaseFavoritesRoute} onEnter={checkAuth} />
    <Route path="/epg" component={EPGRoute} />
    <Route path="/epg/:channel_id" component={EPGRoute} />
    <Route path="/rdvr" component={NpvrRoute} onEnter={checkAuth} />
    <Route path="/notifications" component={NotificationsRoute} onEnter={checkAuth} />
    <Route path="/search/:searchTerm" component={SearchRoute} />
    <Route path="/related/:assetId" component={RelatedRoute} onEnter={checkAuth} />
    <Route path="/purchases" component={PurchasesRoute} onEnter={checkAuth} />
    <Redirect from="*" to="/" />
  </Route>);
};



// WEBPACK FOOTER //
// ./src/routes.js